import * as React from 'react';
import {
  Box,
  createStyles,
  makeStyles,
  Theme,
  Divider,
} from '@material-ui/core';
import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { ApplicationState } from '../../store';
import { Dispatch } from 'redux';
import 'hammerjs';
import { TicketRecord } from '../../Interfaces/Tickets/TicketRecord';
import { fetchTickets } from '../../store/Tickets/TicketsActions';
// Components
import StringResourceManager, { GetString } from '../StringResourceManager';
import WidgetTotalCountTile from '../WidgetTotalCountTile';
import OverviewWidgetChart from '../OverviewWidgetChart';
import { ChartSeriesInterface } from '../../Interfaces/Devices/ChartSeriesInterface';
import { ApiEnums } from '../../Interfaces/ApiEnums';
import { SeriesClickEvent } from '@progress/kendo-react-charts';
import { CompositeFilterDescriptor, State } from '@progress/kendo-data-query';
import { saveTicketFilters } from '../../store/UserSettings/UserSettingsActions';
import { ASSET, COLUMN_TITLE_LANE_CATEGORY } from '../../utils/constants';
import { saveTicketsGridState } from '../../store/UserSettings/UserSettingsActions';

// Styles
const useStylesTicketsOverview = makeStyles((theme: Theme) =>
  createStyles({
    widgetBox: {
      margin: theme.spacing(2),
      width: '450px',
    },
    flexBox: {
      flex: 1,
      flexDirection: 'row',
      display: 'flex',
    },
    widgetItem: {
      flex: 1,
    },
    tileContainer: {
      display: 'flex',
      width: '100%',
      justifyContent: 'center',
    },
    totalCountContainer: {
      display: 'flex',
      height: 140,
      width: '200px',
    },
    overViewTitle: {
      display: 'flex',
      justifyContent: 'center',
    },
  }),
);

export interface TicketCount {
  name: string;
  count: number;
}

export default function TicketsOverview() {
  const classes = useStylesTicketsOverview();
  const dispatch: Dispatch<any> = useDispatch();
  const [refresh, setRefresh] = useState<boolean>(true);

  const tickets: TicketRecord[] = useSelector(
    (state: ApplicationState) => state.ticketsReducer.tickets,
  );

  const isFetchingTickets: boolean = useSelector(
    (state: ApplicationState) => state.ticketsReducer.isFetchingTickets,
  );

  const [storeList, setStoreList] = React.useState<string[]>([]);

  const [openTickets, setOpenTickets] = React.useState<TicketRecord[]>([]);

  const [ticketsCountByStore, setTicketsCountByStore] = React.useState<
    TicketCount[]
  >([]);

  const [ticketCountByStoreSeriesData, setTicketCountByStoreSeriesData] =
    React.useState<ChartSeriesInterface[]>([]);

  const [deviceList, setDeviceList] = React.useState<string[]>([]);

  const [ticketsCountByDeviceCategory, setTicketsCountByDeviceCategory] =
    React.useState<TicketCount[]>([]);

  const [
    ticketCountByDeviceCategorySeriesData,
    setTicketCountByDeviceCategorySeriesData,
  ] = React.useState<ChartSeriesInterface[]>([]);

  useEffect(() => {
    fetchTickets(dispatch, true, true);
  }, []);

  useEffect(() => {
    const openTickets: TicketRecord[] = [];
    for (var i = 0; i < tickets.length; i++) {
      if (tickets[i].Status === ApiEnums.IncidentStatus.Open) {
        openTickets.push(tickets[i]);
      }
    }
    setOpenTickets(openTickets);

    let ticketsByStore: TicketCount[] = [];
    const openTicketStoreList = openTickets.map(
      (item: TicketRecord) => item.SiteNumber,
    );

    for (let i = 0; i < openTicketStoreList.length; ++i) {
      var data: TicketCount = {
        name: openTicketStoreList[i],
        count: 0,
      };

      ticketsByStore.push(data);
    }

    setTicketsCountByStore(ticketsByStore);

    let ticketsByCategory: TicketCount[] = [];
    const openTicketByCategory = openTickets.map(
      (item: TicketRecord) => item.Category,
    );

    for (let i = 0; i < openTicketByCategory.length; ++i) {
      var data: TicketCount = {
        name: openTicketByCategory[i],
        count: 0,
      };

      ticketsByCategory.push(data);
    }

    setTicketsCountByDeviceCategory(ticketsByCategory);
    return () => {};
  }, [tickets]);

  useEffect(() => {
    if (refresh) {
      //fetchTickets(dispatch, true /*getClosed*/);
      setRefresh(false);
    }
  }, [refresh]);

  const ticketCount = () => {
    let seriesData: ChartSeriesInterface[] = [
      {
        status: undefined,
        count: [],
        color: 'red',
      },
    ];

    if (ticketsCountByStore.length == 0) {
      setTicketCountByStoreSeriesData(seriesData);
      return;
    }

    let storeList: string[] = [];
    let list: TicketCount[] = [...ticketsCountByStore];

    for (let i = 0; i < openTickets.length; ++i) {
      let index = ticketsCountByStore.findIndex(
        (a: TicketCount) => a.name === openTickets[i].SiteNumber,
      );

      list[index].count++;
    }

    list.sort((s1, s2) =>
      s1.count < s2.count ? 1 : s1.count > s2.count ? -1 : 0,
    );

    const top5Stores = list.slice(0, 5);

    for (let i = 0; i < top5Stores.length; ++i) {
      if (top5Stores[i].count == 0) continue;

      storeList.push(top5Stores[i].name);
      seriesData[0].count.push(top5Stores[i].count);
    }

    setStoreList(storeList);
    setTicketCountByStoreSeriesData(seriesData);
  };

  const maxChartValueAxisItem = (ticketCount: number) => {
    return ticketCount + 10;
  };

  const getTicketsTileColor = (count: number) => {
    if (count <= 0) return 'green';
    else if (count <= 50) return '#FFB600';
    else return 'red';
  };

  const ticketCountbyCategory = () => {
    let seriesData: ChartSeriesInterface[] = [
      {
        status: undefined,
        count: [],
        color: 'red',
      },
    ];

    if (ticketsCountByDeviceCategory.length == 0) {
      setTicketCountByDeviceCategorySeriesData(seriesData);
      return;
    }

    let storeList: string[] = [];
    let list: TicketCount[] = ticketsCountByDeviceCategory;

    for (let i = 0; i < openTickets.length; ++i) {
      let index = ticketsCountByDeviceCategory.findIndex(
        (a: TicketCount) => a.name === openTickets[i].Category,
      );

      list[index].count++;
    }

    for (let i = 0; i < list.length; ++i) {
      if (list[i].count == 0) continue;

      storeList.push(list[i].name);
      seriesData[0].count.push(list[i].count);
    }

    setDeviceList(storeList);
    setTicketCountByDeviceCategorySeriesData(seriesData);
  };

  useEffect(() => {
    ticketCount();
    ticketCountbyCategory();
  }, [ticketsCountByStore]);

  const onStoreNumberSeriesItemClick = (event: SeriesClickEvent) => {
    let filter: CompositeFilterDescriptor = {
      logic: 'and',
      filters: [
        {
          field: ASSET.FIELD_STORE_NAME,
          operator: 'eq',
          value: event.category,
        },
      ],
    };

    saveTicketFilters(dispatch, filter);

    let gridState: State = {
      filter: {
        logic: 'and',
        filters: [
          {
            field: 'Status',
            operator: 'eq',
            value: 1,
          },
        ],
      },
    };

    saveTicketsGridState(dispatch, gridState);
  };

  const onTicketsByCategorySeriesItemClick = (event: SeriesClickEvent) => {
    let filter: CompositeFilterDescriptor = {
      logic: 'and',
      filters: [],
    };

    saveTicketFilters(dispatch, filter);

    let gridState: State = {
      filter: {
        logic: 'and',
        filters: [
          {
            field: COLUMN_TITLE_LANE_CATEGORY,
            operator: 'eq',
            value: event.category,
          },
        ],
      },
    };

    saveTicketsGridState(dispatch, gridState);
  };

  const graphOrWidgetTotalCountTileClick = () => {
    let filter: CompositeFilterDescriptor = {
      logic: 'and',
      filters: [],
    };

    saveTicketFilters(dispatch, filter);

    let gridState: State = {
      filter: {
        logic: 'and',
        filters: [
          {
            field: 'Status',
            operator: 'eq',
            value: 1,
          },
        ],
      },
    };

    saveTicketsGridState(dispatch, gridState);
  };

  return (
    <React.Fragment>
      <Box className={classes.widgetBox}>
        <div className={classes.overViewTitle}>
          <StringResourceManager
            stringKey="TICKETS_SUMMARY"
            style="overViewTitle"
          />
        </div>
        <div className={classes.tileContainer}>
          <div className={classes.totalCountContainer}>
            <WidgetTotalCountTile
              title={GetString('PAGE_TITLE_TICKETS')}
              count={openTickets.length}
              bgColor={getTicketsTileColor(openTickets.length)}
              textColor="#fff"
              goToScreen="tickets"
              onClick={graphOrWidgetTotalCountTileClick}
              testId="overview_tickets_ticketsCount"
            />
          </div>
        </div>
        <Divider />
        <div className={classes.flexBox}>
          <div className={classes.widgetItem}>
            <OverviewWidgetChart
              chartTitleText={GetString('TOP_STORES_WITH_TICKETS')}
              chartValueAxisItemtitle={GetString('NUMBER_OF_TICKETS')}
              chartCategoryAxisItem={storeList}
              maxChartValueAxisItem={maxChartValueAxisItem(storeList.length)}
              seriesData={ticketCountByStoreSeriesData}
              chartSeriesClick={onStoreNumberSeriesItemClick}
              goToScreen="tickets"
              chartType="bar"
              isRefreshing={isFetchingTickets}
              graphOnclick={graphOrWidgetTotalCountTileClick}
            />
            <OverviewWidgetChart
              chartTitleText={GetString('OPEN_TICKETS_BY_DEVICE_CATEGORY')}
              chartValueAxisItemtitle={GetString('NUMBER_OF_OPEN_TICKETS')}
              chartCategoryAxisItem={deviceList}
              maxChartValueAxisItem={maxChartValueAxisItem(deviceList.length)}
              seriesData={ticketCountByDeviceCategorySeriesData}
              chartType="bar"
              goToScreen="tickets"
              isRefreshing={isFetchingTickets}
              chartSeriesClick={onTicketsByCategorySeriesItemClick}
              graphOnclick={graphOrWidgetTotalCountTileClick}
            />
          </div>
        </div>
      </Box>
    </React.Fragment>
  );
}
